import MySelect from 'Components/Select/Select';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const HeaderNavItem = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 140%;
  color: ${ifProp('isActive', '#262635', '#7e8eaa')};
  cursor: pointer;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
  margin-top: 15px;
  background: #fff;
  box-shadow: 0px 20px 40px 0px #19192e0d;

  @media (max-width: 600px) {
    display: none;
  }

  ${HeaderNavItem} + ${HeaderNavItem} {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 50px;

    @media (max-width: 720px) {
      margin-left: 23px;
    }
  }

  ${HeaderNavItem} {
    @media (max-width: 600px) {
      display: none !important;
    }
  }
`;

export const SubHeaderItem = styled.section`
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #7e8eaa;
  padding: 0px 10px;
  border-radius: 50px;
  cursor: pointer;

  ${ifProp(
    'isActive',
    css`
      font-weight: bold;
      font-size: 14px;
      line-height: 16px;
      display: flex;
      align-items: center;
      text-align: center;
      color: #ffffff;
      background: #2d9cdb;
    `
  )}
`;

export const SubHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 23px;

  @media (max-width: 600px) {
    display: none;
  }

  ${SubHeaderItem} + ${SubHeaderItem} {
    margin-left: 60px;

    @media (max-width: 720px) {
      margin-left: 23px;
    }
  }
`;

export const Flex = styled.div`
  display: flex;
  justify-content: center;
  max-width: 1590px;
  width: 100%;
  margin: 20px auto 0;

  & > div + div {
    margin-left: 60px;
  }

  @media (max-width: 1100px) {
    flex-wrap: wrap;
    margin: 80px auto 0;
    ${ifProp(
      'reversInMobile',
      css`
        flex-direction: column-reverse;
        margin: 0 auto;
        width: fit-content;
      `
    )}

    & > div + div {
      margin-top: 30px;
      margin-left: 0;
    }
  }
`;

export const MySelectStyle = styled(MySelect)`
  max-width: 160px;
  width: 100%;
  .rwSelect__control {
    height: 40px;
    max-width: 160px;
    width: 100%;
    border-radius: 100px;
    font-size: 12px;
    font-weight: 400;
    border: 1px solid #2d9cdb;
  }

  .rwSelect__placeholder {
    color: #2d9cdb;
  }

  svg {
    fill: #2d9cdb;
  }
`;

export const DesktopMenu = styled.div`
  position: fixed;
  top: 63px;
  left: 0;
  right: 0;
  z-index: 14;
  padding: 20px 23px;
  width: 100%;
  display: flex;
  justify-content: center;
  background: #fff;

  ${MySelectStyle} + ${MySelectStyle} {
    margin-left: 10px;
  }
  @media (min-width: 601px) {
    display: none !important;
  }
`;

export const SpinnerStyled = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;
